import FooterCentered from './FooterCentered';
import FooterMinimal from './FooterMinimal';
import FooterCenteredLuxe from './FooterCenteredLuxe';

const VARIANTS = {
  'footer-centered': FooterCentered,
  'footer-minimal': FooterMinimal,
  'footer-centered-luxe': FooterCenteredLuxe,
};

export default function FooterSection({ section, data, theme, settings, rsvpRef }) {
  const Variant = VARIANTS[section.variant] || FooterCentered;
  return <Variant section={section} data={data} theme={theme} settings={settings} rsvpRef={rsvpRef} />;
}
